'use es6';

import React from 'react';
import omit from '../utils/underscore/omit';
import UIAbstractPageTemplate from './UIAbstractPageTemplate';

function UIListingPage(props) {
  return React.createElement(UIAbstractPageTemplate, Object.assign({}, props, {
    horizontalDivider: true
  }));
}

UIListingPage.propTypes = omit(UIAbstractPageTemplate.propTypes, 'horizontalDivider');
UIListingPage.defaultProps = omit(UIAbstractPageTemplate.defaultProps, 'horizontalDivider');
UIListingPage.displayName = 'UIListingPage';
export default UIListingPage;